"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/cookieConsentWaterMarkButton.scss");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const useCookiesConsent_1 = require("../hooks/useCookiesConsent");
const cookieConsentShowModalType_1 = require("../models/cookieConsentShowModalType");
function CookieConsentWaterMarkButton() {
    const { cookieConsentShowModal, setCookieConsentShowModal } = (0, useCookiesConsent_1.useCookiesConsent)();
    return (react_1.default.createElement("div", { className: "cookie-consent-btn-revisit-wrapper cky-revisit-bottom-left" },
        react_1.default.createElement("button", { className: `cookie-consent-btn-revisit ${cookieConsentShowModal === cookieConsentShowModalType_1.CookieConsentShowModalType.HIDE_ALL ||
                cookieConsentShowModal !== cookieConsentShowModalType_1.CookieConsentShowModalType.HIDE_MODAL
                ? "hide"
                : ""}` },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "cookie-consent-btn-revisit-font-awesome-icon close", icon: free_solid_svg_icons_1.faCookieBite, onClick: () => setCookieConsentShowModal(cookieConsentShowModalType_1.CookieConsentShowModalType.SMALL) }))));
}
exports.default = CookieConsentWaterMarkButton;
//# sourceMappingURL=CookieConsentWaterMarkButton.js.map